type PieColour = {
    background: string;
    border: string;
    hex: string;
};

const palette: ReadonlyArray<readonly [number, number, number]> = [
    [255, 99, 132],
    [54, 162, 235],
    [255, 206, 86],
    [75, 192, 192],
    [153, 102, 255],
    [255, 159, 64],
    [100, 100, 100],
    [0, 72, 186],
    [0, 196, 159],
    [23, 162, 184],
    [232, 62, 140],
    [63, 81, 181],
];

const colourIndexes: Record<string, number> = {
    "cyclists": 0,
    "cycle": 0,
    "pedcyc": 0,
    "bus/tram passengers": 1,
    "bus/tram users": 1,
    "bustram": 1,
    "bus pas": 1,
    "buspas": 1,
    "public transport users": 1,
    "ptus": 1,
    "ptu": 1,
    "total rail passengers": 2,
    "rail users": 2,
    "rail": 2,
    "pedestrians": 3,
    "ped": 3,
    "multi vehicle occupants": 4,
    "multivehicleocc": 4,
    "vehicle occupants": 4,
    "cars": 4,
    "single vehicle occupants": 5,
    "singlevehicleocc": 5,
    "coach passengers": 5,
    "scooters": 6,
    "other": 6,
    "water service passengers": 6,
    "taxis": 7,
    "motor cars": 8,
    "light goods vehicles": 9,
    "lgvs": 9,
    "motorcycles": 10,
    "motorbike": 10,
    "public service vehicles": 2,
    "ogvs": 11,
    "ogv 1": 0,
    "ogv (1)": 0,
    "ogv 2": 1,
    "ogv (2)": 1,
};

const normaliseLabel = (label: string) => label.trim().toLowerCase();

const getFallbackIndex = (label: string) => {
    let hash = 5381;
    for (let i = 0; i < label.length; i++) {
        hash = (((hash << 5) + hash) ^ label.charCodeAt(i)) >>> 0;
    }
    return hash % palette.length;
};

export const getPieColour = (label: string): PieColour => {
    const normalised = normaliseLabel(label);
    const index = colourIndexes[normalised] ?? getFallbackIndex(normalised);
    const [red, green, blue] = palette[index];

    return {
        background: `rgba(${red}, ${green}, ${blue}, 0.6)`,
        border: `rgba(${red}, ${green}, ${blue}, 1)`,
        hex: `#${[red, green, blue].map((value) => value.toString(16).padStart(2, "0")).join("")}`,
    };
};

export const getPieBackgroundColours = (segments: ReadonlyArray<{ label: string }>) =>
    segments.map((segment) => getPieColour(segment.label).background);

export const getPieBorderColours = (segments: ReadonlyArray<{ label: string }>) =>
    segments.map((segment) => getPieColour(segment.label).border);
